import React, { Component } from "react";
import { connect } from "react-redux";
import EditActions from "../schema/misc/EditActions";
import CenteredPaper from "../layouts/CenteredPaper";
import { IrqTitle } from "../molecules/IrqTitle";
import { withSubmissionEffect } from "../util/hocs/withSubmissionEffect";
import { withMapUtils } from "../util/hocs/withMapUtils";
import ILearn from "../molecules/ILearn";
import { AddressSelector } from "../molecules/AddressSelector";
import eligibleStateCheck from "../util/eligibleStateCheck";

const navigationCallback = ({ data, navigationsAway }) => {
  // Check if property type is null or Commercial - redirect to Tertiary (Property not supported)
  if (!data.propertyType || data.propertyType === "Commercial") {
    return navigationsAway.Tertiary;
  }

  // Check if state is ineligible or missing required fields - redirect to Secondary (State not supported)
  if (!eligibleStateCheck(data.state, data.stateFips) || !data.county || !data.zip) {
    return navigationsAway.Secondary;
  }

  return navigationsAway.Primary;
};

class IrqAddressView extends Component {
  constructor() {
    super();
    this.state = {
      showMap: false,
      mapHeight: 0,
      center: {
        lat: 38.627,
        lng: 90.1994,
      },
    };
  }

  render() {
    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <IrqTitle
            content={this.props.content}
            icon="/img/svg_icons/location.svg"
          />
          <AddressSelector
            isGoogleApiLoaded={this.props.isGoogleApiLoaded}
            showMap={this.state.showMap}
            center={this.state.center}
            mapHeight={this.state.mapHeight}
            onGoogleMapLoad={this.props.onGoogleMapLoad}
            onGoogleMapUnmount={this.props.onGoogleMapUnmount}
            placesService={this.props.placesService}
            customFormEdit={this.props.customFormEdit}
            googleMap={this.props.googleMap}
            setState={this.setState.bind(this)}
            setAddress={({
              county,
              countyFips,
              street,
              city,
              state,
              stateFips,
              zip,
              propertyType,
              neighborhood,
            }) => {
              this.props.customFormEdit("county", county);
              this.props.customFormEdit("countyFips", countyFips);
              this.props.customFormEdit("street", street);
              this.props.customFormEdit("city", city);
              this.props.customFormEdit("state", state);
              this.props.customFormEdit("stateFips", stateFips);
              this.props.customFormEdit("zip", zip);
              this.props.customFormEdit("propertyType", propertyType);
              this.props.customFormEdit("neighborhood", neighborhood);
            }}
          />

          <EditActions
            canSubmit={this.props.isValid}
            customSubmit={() => {
              const navigateTo = navigationCallback(this.props);
              if (
                !eligibleStateCheck(this.props.data.state, this.props.data.stateFips) ||
                !this.props.data.county ||
                !this.props.data.zip
              ) {
                this.props.navigationContext.goNext(navigateTo);
                return;
              }
              this.props.navigationContext.goNext(navigateTo);
            }}
          />
        </CenteredPaper>
      </ILearn>
    );
  }
}

export default withSubmissionEffect(
  connect()(withMapUtils(IrqAddressView)),
  navigationCallback
);
